import { Card, Col, List, Row } from "antd";
import { memo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../../../../assets/staticImages/planningForm1.png";
import img2 from "../../../../assets/staticImages/planningForm2.png";
import img3 from "../../../../assets/staticImages/planningForm3.png";
import dummyImg from "../../../../assets/dummy.jpg";
import { TextComponent } from "../../../../components";
import Meta from "antd/es/card/Meta";
import styles from "./PlanningForm.module.css";
import { useDispatch, useSelector } from "react-redux";

import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";

const RenderItem = memo(({ item, index, setForm }) => {
  const navigate = useNavigate();

  return (
    <List.Item>
      <Card
        hoverable
        style={{ width: "100%" }}
        cover={
          <img
            className={styles.image}
            src={item?.vendor_image ? item?.vendor_image : dummyImg}
            alt="example"
          />
        }
        onClick={() =>
          navigate("/events/eventDetail/section", {
            state: { headrTitle: `Planning Form`, item },
          })
        }
      >
        <Meta
          style={{ textAlign: "center" }}
          title={
            <TextComponent
              text={item?.vendor_name ? item?.vendor_name : "--"}
            />
          }
          // description="www.instagram.com"
        />
      </Card>
    </List.Item>
  );
});

const data = [
  {
    title: "Wedding Ceremony",
    img: img1,
  },
  {
    title: "Birthday Party",
    img: img2,
  },
  {
    title: "Engagement Ceremony",
    img: img3,
  },
];

const PlanningForm = () => {
  const ClientPlanningForm = useSelector(
    (state) => state.EventReducer.ClientPlanningForm
  );
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const dispatch = useDispatch();
  // console.log("EventDetails============================>", EventDetails);

  const { state } = useLocation();

  useEffect(() => {
    getTemplate();
  }, []);

  const getTemplate = () => {
    // setloading(true);
    // console.log("======================df=gdfggdfgd===========");
    let eventData = {
      event_id: state?.eventData?.id,
    };
    dispatch(EventMiddleware.getClientPlanningForm(eventData))
      .then(() => {})
      .catch((err) => {
        // setloading(false);
        // console.log(err);
      });
  };
  return (
    <>
      <List
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        style={{ margin: "40px auto 20px auto" }}
        dataSource={ClientPlanningForm ? ClientPlanningForm : []}
        renderItem={(item, index) => <RenderItem item={item} index={index} />}
      />
    </>
  );
};

export default PlanningForm;
